var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.6579H24.5M10.7632 10.8158H10.7717M14.5526 10.8158H14.5612M6.5 16.5C6.5 12.2577 6.5 10.1356 7.81779 8.81779C9.13558 7.5 11.2567 7.5 15.5 7.5C19.7423 7.5 21.8644 7.5 23.1822 8.81779C24.5 10.1356 24.5 12.2567 24.5 16.5C24.5 20.7423 24.5 22.8644 23.1822 24.1822C21.8644 25.5 19.7433 25.5 15.5 25.5C11.2577 25.5 9.13558 25.5 7.81779 24.1822C6.5 22.8644 6.5 20.7433 6.5 16.5Z",
    stroke: "#4A5568",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7109 17.4473L12.8734 18.4486C13.3613 18.8702 13.6057 19.0805 13.6057 19.342C13.6057 19.6035 13.3613 19.8138 12.8734 20.2354L11.7109 21.2367M15.5004 21.2367H19.2899",
    stroke: "#4A5568",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.834fa33419927bd5f62639cd6e74f08d.svg";
export { ForwardRef as ReactComponent };